<ng-container *ngIf="loading;else template">

<iho-skeleton height="360px" width="100%"  />
<div class="container">
  <div class="w-full my-8xl">
    <iho-skeleton height="1.5rem" width="10rem" class="rounded-full mx-2" />
    <iho-skeleton height="1.5rem" width="20rem" class="rounded-full mx-2" />
    </div>
    <div class="grid lg:grid-cols-4 grid-cols-1 gap-lg my-3xl">
      <div class="card-items rounded-lg border border-solid border-gray-ds w-full h-[350px]" 
      *ngFor="let item of [].constructor(4)">
        <iho-skeleton height="350px" width="100%" class="rounded-t-lg h-[192px]" />
      </div>
    </div>
</div>


</ng-container>
<ng-template #template>
  <div class="w-full relative flex justify-center items-center text-white"
   id="hero-image-foreign-hotels">
   <img src="/assets/images/foreign-hotels.jpg" height="360" width="100%" alt="هتل های خارجی">
    <h1 class="absolute">هتل های خارجی</h1>
  </div>
<div class="container">
 <div class="w-full my-8xl" id="popular-destinations">
  <div class="flex justify-between">
   <div>
    <h4 class="text-h6 text-gray-ds-400 font-bold">محبوب‌ترین مقاصد خارجی</h4>
    <p class="text-p text-gray-ds-300 my-lg">
     رزرو آنلاین بیش از {{ dataSource.PopularDestinations.TotalAccommodations }} واحد اقامتی در
     مقاصد خارجی
    </p>
   </div>
  </div>
  <div class="grid lg:grid-cols-4 grid-cols-1 gap-lg my-3xl">
   <div
    class="card-items rounded-lg border border-solid border-gray-ds w-full h-[350px]"
    *ngFor="let item of dataSource.PopularDestinations.List; let i = index">
    <a [href]="item.Link">
     <img
      [src]="item.PictureUrl"
      (error)="item.PictureUrl  = cdnUrl + '/images/no-image.jpg'" 
      alt="Card image"
      class="w-full object-cover rounded-t-lg h-[192px]" />
     <div class="card-items-content p-lg">
      <h3 class="text-p text-gray-ds-900 font-bold">هتل های {{ item.Title }}</h3>
      <div class="w-full truncate text-small text-gray-ds-400 font-normal">
       <span class="iho-icon-location-06 text-small"></span>
       کشور {{ item.CountryName }}
      </div>
      <div class="flex">
       <span class="iho-icon-city-01 text-small text-gray-ds-400"></span>
       <span class="mx-sm text-gray-ds-400 text-small font-normal">
        {{ item.TotalAccommodations }}
       </span>
       <span class="text-gray-ds-400 text-small font-normal">واحد اقامتی</span>
      </div>
      <div
       class="flex float-start justify-center mt-2 rounded-full items-center text-small px-lg text-error-500 bg-error-100 border border-solid border-error-100">
       <span class="iho-icon-hot-price text-xl"></span>
       <span
        >تا <b>{{ item.DiscountPercent }}</b
        >% تخفیف</span
       >
      </div>
     </div>
    </a>
   </div>
  </div>
  <h4 class="text-h6 text-gray-ds-400 font-bold">مقاصد خارجی</h4>
  <div class="grid lg:grid-cols-4 grid-cols-1 gap-4">
    
      <div>
        <ng-container *ngFor="let item of dataSource.Destinations; let index = index">
          <ng-container *ngIf="index % 4 === 0">
            <ng-container  *ngTemplateOutlet="column; context: { itemData: item,index: index}" />
          </ng-container>
        </ng-container>
      </div>
     
      <div>
        <ng-container *ngFor="let item of dataSource.Destinations; let index = index">
          <ng-container *ngIf="index % 4 === 1">
            <ng-container  *ngTemplateOutlet="column; context: { itemData: item , index: index}" />
          </ng-container>
        </ng-container>
      </div>
      <div>
        <ng-container *ngFor="let item of dataSource.Destinations; let index = index">
          <ng-container *ngIf="index % 4 === 2">
            <ng-container  *ngTemplateOutlet="column; context: { itemData: item , index: index}" />
          </ng-container>
        </ng-container>
      </div>
      <div>
        <ng-container *ngFor="let item of dataSource.Destinations; let index = index">
          <ng-container *ngIf="index % 4 === 3">
            <ng-container  *ngTemplateOutlet="column; context: { itemData: item , index: index}" />
          </ng-container>
        </ng-container>
      </div>
  </div>
 </div>


 <ng-template #column let-itemData="itemData" let-index="index">
  <div
    class="rounded border border-gray-ds border-solid mt-4 max-h-72 overflow-hidden"
  >
    <div class="rounded-t text-black-900 hover:bg-transparency-primary-10 hover:text-primary-500 flex items-center justify-between transition-all duration-200 p-sm py-4">
      <a [href]="itemData.Link"  class="flex justify-between items-center w-full">
        <h5 class="font-bold">{{ itemData.Title }}</h5>
        <span>({{ itemData.TotalAccommodations }})</span>
      </a>
       
    </div>   
    <div class="border-solid border-t border-gray-ds">
      <iho-recursive-destinations [destinations]="itemData.Destinations" />
    </div>
   
  </div>
  <div (click)="showMore(index,$event)" *ngIf="itemData.Destinations.length > 5"
  class="showMore-{{index}} w-full cursor-pointer text-small rounded-b hover:bg-transparency-primary-10 text-primary-500 flex justify-center items-center border-solid border border-gray-ds p-2">
    <span>{{showIcon[index] ? 'بستن' : 'مشاهده بیشتر'}}</span>
    <i class="ico-Down text-2xl" [ngClass]="showIcon[index] ? 'rotate-180' : ''"></i>
  </div>
 </ng-template>
</div>

</ng-template>